import React from "react";
import { ButtonWithSound } from "./button_with_sound";
import { Text } from "./typography";

interface ClickableTextProps {
  text: string;
  onClick?: (e: React.MouseEvent) => void;
  /** When provided, renders a real anchor (opens in a new tab) instead of a button. */
  href?: string;
  className?: string;
  Icon?: React.ElementType;
  children?: React.ReactNode;
  tabIndex?: number;
  ariaDisabled?: boolean;
}

const ClickableText: React.FC<ClickableTextProps> = ({
  text,
  onClick,
  href,
  className = "",
  Icon,
  children,
  tabIndex,
  ariaDisabled = false,
}) => {
  const combinedClassName = `group flex items-center gap-2 transition-all duration-150 ease-in-out \
                  hover:opacity-80 hover:scale-105 active:scale-95 ${className}`;

  const content = (
    <>
      <Text variant="body" tone="dark" className="transition-all duration-150 ease-in-out">
        {text}
      </Text>
      {Icon ? (
        <Icon className="h-5 w-5 transition-all duration-150 ease-in-out group-hover:translate-x-1" />
      ) : null}
      {children}
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={combinedClassName}
        tabIndex={tabIndex}
        aria-disabled={ariaDisabled}
      >
        {content}
      </a>
    );
  }

  return (
    <ButtonWithSound
      onClick={onClick}
      className={combinedClassName}
      tabIndex={tabIndex ?? -1}
      type="button"
      aria-disabled={ariaDisabled}
    >
      {content}
    </ButtonWithSound>
  );
};

export default ClickableText;
